import { State } from "@/stores/trip/types.ts";

export default (): State => ({
  contextType: "",
  tripListResponse: {
    results: [],
    count: 0,
  },
});
